import { render } from "./VerifyEmail.vue?vue&type=template&id=7456acbe&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"

import "./VerifyEmail.vue?vue&type=style&index=0&id=7456acbe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7456acbe"]])

export default __exports__